import React, { useEffect, useState } from "react";
import property from "assets/images/property.jpeg";
import { ReactComponent as AreaIcon } from "assets/icons/area_black.svg";
import { ReactComponent as BedroomIcon } from "assets/icons/bed_black.svg";
import { ReactComponent as BathIcon } from "assets/icons/bath_black.svg";
import { ReactComponent as LocationIcon } from "assets/icons/location.svg";
import useProperties from "hooks/useProperties";
import { formatCurrency } from "utils/formatNumber";
import useAuth from "hooks/useAuth";
import AnimatedDialogLayout from "components/Dialog/AnimatedDialogLayout";
import SearchCard from "components/Card/SearchCard";
import PaginatedPropertiesPopup from "./PaginatedPropertiesPopup";
import PropertyPopup from "components/Dialog/PropertyPopup";

const PropertiesWithTopGrossYield = () => {
  const {
    getTopGrossYieldProperty,
    topGrossYieldProperties,
    isFetchingTopGrossYieldProperty,
    setSelectedPropertyPopup,
    selectedPropertyPopup,
    togglePaginatedPropertyPopup,
  } = useProperties();
  const initialDisplayCount = 3; // Initally 3 property will display
  const { user } = useAuth();

  useEffect(() => {
    getTopGrossYieldProperty();
  }, [user]);

  const handleOpenPaginatedPropertyPopup = () => {
    document.body.style.overflow = "hidden";
    togglePaginatedPropertyPopup("topGrossYield");
  };

  const displayedProperties = topGrossYieldProperties.slice(
    0,
    initialDisplayCount
  );

  return (
    <>
      <div className="rounded-[15px] w-full bg-[#1DA1F217] px-[15px] pb-[22px] pt-[18px]">
        <h1 className="font-semibold text-[#000000] text-[22px] leading-[30px]">
          Scopri{" "}
          <span className="text-[#337731] font-bold text-[32px]">14</span> Nuove
          Proprietà trovate per te con un{" "}
          <span className="text-[#337731]">ROI</span> più alto della media.
        </h1>
        <div className="mt-[18px] h-[calc(100%-170px)]">
          {displayedProperties.length > 0 &&
            displayedProperties?.map((property, index) => (
              <div
                key={property._id}
                onClick={() =>
                  setSelectedPropertyPopup({
                    property,
                    id: "topGrossYieldProperty",
                  })
                }
              >
                <div className="h-[138px] flex items-center">
                  <div className="h-full flex-shrink-0 w-[40%] relative">
                    <img
                      src={property?.pictures[0]}
                      alt="property"
                      className="w-full flex-shrink-0 rounded-[5px] h-full object-cover"
                    />
                    <button className="block absolute bottom-[5px] left-1/2 -translate-x-1/2 w-max flex-shrink-0   md:hidden text-[#337731] bg-white rounded-[5px] px-4 h-[22px] text-[15px] font-bold">
                      ROI {property?.gross_yield}%
                    </button>
                  </div>
                  <div className="w-[60%] pl-[17px]">
                    <h1 className="text-black text-[15px] font-medium truncate leading-[30px]">
                      {property.title}
                    </h1>
                    <div className="flex items-center space-x-1 h-5">
                      <LocationIcon className="text-black" />
                      <p className="text-black text-[12px] font-normal">
                        {property?.location?.name}
                      </p>
                    </div>
                    <div className="flex items-center space-x-[22px] mt-[8px] h-5">
                      <div className="flex items-center space-x-[5px]">
                        <BedroomIcon className="text-black" />
                        <p className="text-black text-nowrap text-[10px] xs:text-[16px] leading-5 font-normal">
                          {property?.bedrooms} Stanze
                        </p>
                      </div>
                      <div className="flex items-center space-x-[5px]">
                        <BathIcon className="text-black" />
                        <p className="text-black text-nowrap text-[10px] xs:text-[16px] leading-5 font-normal">
                          {property?.bathrooms} Bagni
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center space-x-[5px] mt-[8px] h-5">
                      <AreaIcon className="text-black" />
                      <p className="text-black text-[10px] xs:text-[16px] leading-5 font-normal">
                        {property?.total_area} m
                        <sup className="ml-[2px]">2</sup>
                      </p>
                    </div>
                    <div className="flex items-center justify-between mt-[5px]">
                      <h4 className="text-black leading-[22px] font-bold text-[15px]">
                        {formatCurrency(
                          property.sale_price,
                          property?.sale_currency
                        )}
                      </h4>
                      <button className="hidden md:block text-[#337731] bg-white rounded-[5px] px-[9px] h-[30px] text-[18px] font-bold">
                        ROI {property?.gross_yield}%
                      </button>
                    </div>
                  </div>
                </div>

                <hr
                  style={{
                    opacity: index < displayedProperties.length - 1 ? 1 : 0,
                  }}
                  className="mt-[18px] mb-5 h-[1px] border-primary border"
                />
              </div>
            ))}
        </div>
        {displayedProperties.length > 2 && (
          <button
            onClick={handleOpenPaginatedPropertyPopup}
            className="bg-primary w-full h-[60px] rounded-[10px] text-white text-center text-[15px] font-medium underline"
          >
            Mostra Lista Completa
          </button>
        )}
      </div>
      <PaginatedPropertiesPopup
        properties={topGrossYieldProperties}
        id={"topGrossYield"}
      />
      {/* Property card on click mini cell*/}
      <PropertyPopup popupType="topGrossYieldProperty" isOrganisePage={true} />
    </>
  );
};

export default PropertiesWithTopGrossYield;
